/**
 * Simple table
 */
;(function table($){

  $(document).ready(init);

  // Variables for active tabs on click
  var BTN_SEL = '.field--name-field-accordion-title-dispositif > .field__item';
  var BTN_ACTIVE_CLASS = 'Table-link--active';
  var BTN_DISABLED_CLASS = 'Js-Disabled';
  var TAB_SEL = '.field--name-field-accordion-item-dispositif > .field__item';

  // Variables for disable tabs if there is no content
  var CAMPUS = '.field--name-field-accordion-item-dispositif';
  var CAMPUS_DISABLED_CLASS = 'Table-link--disabled';
  var CAMPUS_AVAILABLE_CLASS = 'Table-link--available';
  var CAMPUS_SEL = '.field--name-field-accordion-title-dispositif';

  var Teaser_select = '.Teaser-date.active';
  var Table_intro = ".dispositif .Table-intro";
  var Table_accordion = ".dispositif .field--name-field-accordion-item-dispositif";

  function init(){

    $(BTN_SEL).each(function(index){

        if (typeof $(TAB_SEL)[index] === "undefined") {
            $($(BTN_SEL)[index]).addClass(BTN_DISABLED_CLASS);
        }

    var arrayMappingEmptyParagraphPosition = new Array();
    var arrayMappingNotEmptyParagraphPosition = new Array();
    $(CAMPUS).children().each(function(index){
      if($( this ).children().children().children().length === 0){
        arrayMappingEmptyParagraphPosition.push(index);
        $( this ).addClass("paragraph-empty");
      }else{
          arrayMappingNotEmptyParagraphPosition.push(index);
          $( this ).addClass("paragraph-not-empty");
      }
    });

    var listCampus =$(CAMPUS_SEL).children();
    $.each(arrayMappingEmptyParagraphPosition , function(index, val) {
      $(listCampus[val]).addClass(CAMPUS_DISABLED_CLASS);
    });
    $.each(arrayMappingNotEmptyParagraphPosition , function(index, val) {
      $(listCampus[val]).addClass(CAMPUS_AVAILABLE_CLASS);

    });

      if($(this).hasClass(CAMPUS_DISABLED_CLASS) === false ){
        $( this ).on('click', function() {
            if (typeof $(TAB_SEL)[index] !== "undefined") {
                $(BTN_SEL).removeClass(BTN_ACTIVE_CLASS);
                $(this).addClass(BTN_ACTIVE_CLASS);
                showTab(index);
            }
        });
      }
    });
      $(TAB_SEL).hide();
      var select_link_available = $('.'+CAMPUS_AVAILABLE_CLASS);
      $(select_link_available[0]).show();
      $(select_link_available[0]).addClass(BTN_ACTIVE_CLASS);
      $($('.paragraph-not-empty')[0]).show();



  }

  // get value of the nav on table

    if ($(Teaser_select).length === 0) {
      return;
    }
    if ($(Teaser_select)!= null) {
        var color = $(Teaser_select).css('backgroundColor');

        if (typeof color !== "undefined") {
            hexc(color);
            $(Table_intro).css('background-color', color);
            $(Table_accordion).css('background-color', color);
        }
    }

    // parse it for get the hexa value

    function hexc(colorval) {
        var parts = colorval.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        delete(parts[0]);
        var i ;
        for ( i = 1; i <= 3; ++i) {
            parts[i] = parseInt(parts[i]).toString(16);
            if (parts[i].length == 1) parts[i] = '0' + parts[i];
        }
        color = '#' + parts.join('');
    }

    function showTab(index) {
        $(TAB_SEL).hide();
        $($(TAB_SEL)[index]).show();
    }
    // return to the part who need to change

})(jQuery);